var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{attrs:{"href":_vm.href,"target":_vm.target,"rel":_vm.rel}},[_vm._t("default"),_vm._v(" "),_c('i',{staticClass:"fas fa-external-link-alt p-down"})],2)}
var staticRenderFns = []
export { render, staticRenderFns }